<template>
  <div class="modal_card edit_ticket">
    <div class="header">
      <h4 class="title">
        {{ translate('support.add') }}
      </h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-12" v-if="false">
            <fg-input
              v-model="ticket_info.device_id"
              type="text"
              :label="translate('support.device')"
              :placeholder="translate('support.device')"
              readonly
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <sis-select
                v-model="ticket_info.topic_id"
                :options="topic_list"
                :placeholder="translate('support.subject')"
                :label="translate('support.subject')"
                :clearable="false"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ translate('support.descr') }}</label>
              <textarea
                v-model="ticket_info.text"
                rows="5"
                class="form-control border-input"
                :placeholder="translate('support.descr')"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="open_ticket"
            :disabled='disabled_btn'
          >
            {{ translate("support.add") }}
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
          >
            Cancel
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>

import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm";

export default {
  name: "NewTicket",
  props: ['ticket', 'device_id'],
  data () {
    return {
      ticket_info: {},
      disabled_btn: false,
      confirm: false,
    }
  },
  beforeMount () {
    this.ticket_info = {...this.ticket}
    if (this.device_id) {
      this.ticket_info.device_id = this.device_id
    }
  },
  computed:{
    topic_list(){
      let list = []
      for (let topic of this.$store.getters.getTicketTopics) {
        list.push({id: topic.id, label: topic.name})
      }
      return list
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    confirm_open_ticket () {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('support.confirm_ticket')
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          },
          confirm: () => {
            this.confirm = true
            this.open_ticket()
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'dynamic-modal'})

    },
    open_ticket(){
      this.disabled_btn = true
      this.ticket_info.confirm = this.confirm
      this.$http.v1.openTicket(this.ticket_info, (response) => {
        if (response.data.error){
          this.confirm_open_ticket()
        }else{
          this.global_notify('info', this.translate('support.new_ticket'))
          this.$store.dispatch('ticketList')
          this.$emit('update')
          this.$emit('close')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .modal_card{
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header{
      .title{
        margin-top: 15px;
      }
    }
    .content{
      textarea{
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
        height: 200px;
      }
    }
  }

</style>
